import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { axiosGetData } from "@shared/api/clients";

import {
  GetAdminPermissionsRequest,
  GetAdminPermissionsResponse,
} from "./permissions.types";

export const ADMIN_PERMISSIONS_ENDPOINT = "v1/admin/permissions";
export const ADMIN_PERMISSIONS_QUERY_KEY = ["admin", "permissions"];

export const fetchAdminPermissions = async (
  params: GetAdminPermissionsRequest,
): Promise<GetAdminPermissionsResponse> => {
  return axiosGetData<GetAdminPermissionsResponse>(
    ADMIN_PERMISSIONS_ENDPOINT,
    { ...params },
  );
};

export const useAdminPermissionsQuery = (
  params: Partial<GetAdminPermissionsRequest>,
  options?: { enabled?: boolean },
) => {
  const isReady = Boolean(
    params.complexId && params.structureId && params.userId,
  );

  return useQuery<GetAdminPermissionsResponse, AxiosError>({
    queryKey: [
      ...ADMIN_PERMISSIONS_QUERY_KEY,
      params.complexId ?? "",
      params.structureId ?? "",
      params.userId ?? "",
    ],
    queryFn: () =>
      fetchAdminPermissions(params as GetAdminPermissionsRequest),
    enabled: isReady && (options?.enabled ?? true),
    retry: false,
    staleTime: 1000 * 30,
  });
};
